module.exports = __webpack_public_path__ + "assets/img/classroom_3.985e32f1.jpg";